import React, { useCallback, useMemo } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useQualityConfigs } from '../../context/qualityConfigs';
import { SelfServiceIntegration } from './selfService/views/SelfServiceIntegration';

const Requirements = [{ source: 'jira' }, { source: 'azureDevops', namespace: undefined }];
const TestCases = [
  { source: 'jira' },
  { source: 'azureDevops', namespace: 'testCase' },
  { source: 'testrail', namespace: 'testCase' },
  { source: 'xrayCloud', namespace: 'testCase' },
  { source: 'zephyrScale', namespace: 'testCase' },
];

const AllowedSources: Record<string, any> = {
  req1: Requirements,
  req2: Requirements,
  req3: Requirements,
  testCase1: TestCases,
  testCase2: TestCases,
  testCase3: TestCases,
  testResult: [
    { source: 'azureDevops', namespace: 'testResult' },
    { source: 'testrail', namespace: 'testResult' },
    { source: 'xrayCloud', namespace: 'testResult' },
    { source: 'zephyrScale', namespace: 'testResult' },
  ],
};

export const SelfServiceView: React.FC = () => {
  const { state } = useLocation();
  const { configs, loading } = useQualityConfigs();
  const navigate = useNavigate();

  const selectedConfig = useMemo(() => {
    return [...configs, { type: 'testResult', label: 'Test Results' }].find((config) => config.type === state.type);
  }, [configs, state.type]);

  const onClose = useCallback(() => {
    navigate('../');
  }, [navigate]);

  if (!state || !state.type || loading || !selectedConfig) {
    console.log(loading, selectedConfig, state, configs);
    return null;
  }

  return (
    <SelfServiceIntegration
      allowedSources={AllowedSources[selectedConfig.type as string]}
      template={{}}
      mappingFields={[]}
      name={``}
      onClose={onClose}
      subTitle={selectedConfig.label}
    />
  );
};
